import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../utils/api';

export default function OwnerHome({ user, onLogout }) {
  const navigate = useNavigate();
  const [community, setCommunity] = useState({ notices: [], votes: [] });
  useEffect(() => { API.get('/community/owner-home').then(r => setCommunity(r.data)).catch(() => {}); }, []);
  const activeVotes = (community.votes || []).filter(v => v.effective_status === 'open' && !v.has_voted).length;


  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div>
          <div style={styles.welcome}>您好，{user.real_name}</div>
          <div style={styles.room}>🏠 {user.room_no || '未设置房号'}</div>
        </div>
        <button style={styles.logoutBtn} onClick={onLogout}>退出</button>
      </div>


      <button style={styles.communityPanel} onClick={() => navigate('/owner/community')}>
        <div style={styles.communityHead}><b>📣 物业通告</b><span>查看全部与投票 ›</span></div>
        {(community.notices || []).length ? (community.notices || []).slice(0,3).map(n =>
          <div key={n.id} style={styles.noticeLine}>• {n.title}</div>
        ) : <div style={styles.noticeEmpty}>暂无最新通告</div>}
        {activeVotes > 0 && <div style={styles.voteAlert}>🗳️ 有 {activeVotes} 项业主投票等待您参与</div>}
      </button>

      <div style={styles.cards}>
        <button style={{...styles.card, background: 'linear-gradient(135deg, #173f73, #2d7dd2)'}}
          onClick={() => { window.location.href = '/dashboard'; }}>
          <div style={styles.cardIcon}>📺</div>
          <div style={styles.cardTitle}>物业看板</div>
          <div style={styles.cardDesc}>查看全部物业任务和投诉建议</div>
        </button>

        <button style={{...styles.card, background: 'linear-gradient(135deg, #ff7a45, #ff4d4f)'}}
          onClick={() => navigate('/owner/repair')}>
          <div style={styles.cardIcon}>🔧</div>
          <div style={styles.cardTitle}>报修</div>
          <div style={styles.cardDesc}>家中或公共设施故障</div>
        </button>

        <button style={{...styles.card, background: 'linear-gradient(135deg, #1890ff, #2d7dd2)'}}
          onClick={() => navigate('/owner/complaint')}>
          <div style={styles.cardIcon}>📢</div>
          <div style={styles.cardTitle}>投诉与建议</div>
          <div style={styles.cardDesc}>服务问题或意见反馈</div>
        </button>

        <button style={{...styles.card, background: 'linear-gradient(135deg, #52c41a, #389e0d)'}}
          onClick={() => navigate('/owner/records')}>
          <div style={styles.cardIcon}>📋</div>
          <div style={styles.cardTitle}>我的记录</div>
          <div style={styles.cardDesc}>查看处理进度</div>
        </button>

        <button style={{...styles.card, background: 'linear-gradient(135deg, #13a8a8, #08979c)'}}
          onClick={() => navigate('/owner/face')}>
          <div style={styles.cardIcon}>📷</div>
          <div style={styles.cardTitle}>更新门禁人脸</div>
            <div style={styles.cardDesc}>照片不清晰或识别失败，可重新拍摄提交审核</div>
        </button>


        <button style={{...styles.card, background: 'linear-gradient(135deg, #07c160, #089f52)'}}
          onClick={() => navigate('/owner/visitor')}>
          <div style={styles.cardIcon}>🎫</div>
          <div style={styles.cardTitle}>访客邀请</div>
          <div style={styles.cardDesc}>生成二维码，微信发送给访客登记</div>
        </button>

        <button style={{...styles.card, background: 'linear-gradient(135deg, #cf5b18, #f59e0b)'}}
          onClick={() => navigate('/owner/fees')}>
          <div style={styles.cardIcon}>💰</div>
          <div style={styles.cardTitle}>我的费用</div>
          <div style={styles.cardDesc}>查看应收、已缴和欠费记录</div>
        </button>

        <button style={{...styles.card, background: 'linear-gradient(135deg, #0077b6, #00b4d8)'}}
          onClick={() => navigate('/owner/water')}>
          <div style={styles.cardIcon}>💧</div>
          <div style={styles.cardTitle}>我的水表</div>
          <div style={styles.cardDesc}>查看抄表记录</div>
        </button>

        <button style={{...styles.card, background: 'linear-gradient(135deg, #8b4513, #c47a3a)'}}
          onClick={() => navigate('/owner/entertainment')}>
          <div style={styles.cardIcon}>🎮</div>
          <div style={styles.cardTitle}>休闲娱乐</div>
          <div style={styles.cardDesc}>中国象棋 · 人机对战 · 双人对弈</div>
        </button>

        <button style={{...styles.card, background: 'linear-gradient(135deg, #722ed1, #531dab)'}}
          onClick={() => navigate('/owner/property')}>
          <div style={styles.cardIcon}>👤</div>
          <div style={styles.cardTitle}>我的房屋档案</div>
        </button>
      </div>

      <div style={styles.footer}>云彩环境物业公司 · 大诚瓯江印象</div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', background: '#f5f7fa', padding: '20px 16px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'linear-gradient(90deg, #1a4a8a, #2d7dd2)', borderRadius: '14px', padding: '18px 20px', marginBottom: '20px', boxShadow: '0 4px 16px rgba(26,74,138,0.25)' },
  welcome: { color: '#fff', fontSize: '17px', fontWeight: 700 },
  room: { color: 'rgba(255,255,255,0.85)', fontSize: '13px', marginTop: '4px' },
  logoutBtn: { background: 'rgba(255,255,255,0.2)', color: '#fff', border: 'none', borderRadius: '16px', padding: '6px 14px', fontSize: '13px', cursor: 'pointer' },
  communityPanel: { width: '100%', boxSizing: 'border-box', border: '1px solid #dbe7f5', borderRadius: '14px', background: '#fff', padding: '14px 15px', marginBottom: '16px', textAlign: 'left', boxShadow: '0 3px 12px rgba(0,0,0,0.07)' },
  communityHead: { display: 'flex', justifyContent: 'space-between', color: '#1a4a8a', fontSize: '15px', marginBottom: '9px' },
  noticeLine: { color: '#333', fontSize: '13px', padding: '5px 0', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' },
  noticeEmpty: { color: '#999', fontSize: '13px', padding: '6px 0' },
  voteAlert: { background: '#fff7e6', color: '#cf5b18', borderRadius: '8px', padding: '8px 9px', fontSize: '12px', fontWeight: 700, marginTop: '8px' },
  cards: { display: 'flex', flexDirection: 'column', gap: '16px' },
  card: { border: 'none', borderRadius: '16px', padding: '24px 20px', textAlign: 'left', cursor: 'pointer', boxShadow: '0 6px 16px rgba(0,0,0,0.12)' },
  cardIcon: { fontSize: '32px', marginBottom: '8px' },
  cardTitle: { color: '#fff', fontSize: '19px', fontWeight: 800, marginBottom: '4px' },
  cardDesc: { color: 'rgba(255,255,255,0.85)', fontSize: '13px' },
  footer: { textAlign: 'center', color: '#bbb', fontSize: '12px', marginTop: '30px' }
};
